// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--bg-primary);
}

.login-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 40px;
  width: 90%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.login-title {
  font-size: 29px;
  font-weight: 700;
  letter-spacing: -.9px;
  margin: 12px 0 6px;
  color: var(--text-primary);
}

.login-subtitle {
  font-size: 14px;
  color: var(--text-secondary);
}

.login-btn {
  width: 100%;
  justify-content: center;
  padding: 12px;
  margin-top: 8px;
  font-size: 14px;
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-switch {
  text-align: center;
  margin-top: 20px;
  font-size: 13px;
  color: var(--text-muted);
}

.login-switch button {
  background: none;
  border: none;
  color: var(--accent);
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}

.login-switch button:hover {
  color: var(--accent-hover);
}`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".login-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: var(--bg-primary);\n}\n\n.login-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 40px;\n  width: 90%;\n  max-width: 400px;\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.login-title {\n  font-size: 29px;\n  font-weight: 700;\n  letter-spacing: -.9px;\n  margin: 12px 0 6px;\n  color: var(--text-primary);\n}\n\n.login-subtitle {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.login-btn {\n  width: 100%;\n  justify-content: center;\n  padding: 12px;\n  margin-top: 8px;\n  font-size: 14px;\n}\n\n.login-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.login-switch {\n  text-align: center;\n  margin-top: 20px;\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n.login-switch button {\n  background: none;\n  border: none;\n  color: var(--accent);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.login-switch button:hover {\n  color: var(--accent-hover);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
